import { render } from "./EmailEdit.vue?vue&type=template&id=19779706&scoped=true"
import script from "./EmailEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailEdit.vue?vue&type=script&setup=true&lang=js"

import "./EmailEdit.vue?vue&type=style&index=0&id=19779706&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19779706"],['__file',"resources/js/modules/email/components/EmailEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19779706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19779706', __exports__)) {
    api.reload('19779706', __exports__)
  }
  
  module.hot.accept("./EmailEdit.vue?vue&type=template&id=19779706&scoped=true", () => {
    api.rerender('19779706', render)
  })

}


export default __exports__